import { Component } from '@angular/core';

@Component({
    selector: 'bb-logo-page-ui',
    templateUrl: './bb-logo-page-ui.component.html',
    standalone: false,
})
export class LogoPageComponent {}
